import { motion, AnimatePresence } from 'motion/react';
import { Loader2 } from 'lucide-react';
import { useLoading } from '@/hooks/use-loading';

export default function LoadingOverlay() {
  const { isLoading, loadingMessage } = useLoading();

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          key="loading-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-background/80 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.85, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="flex flex-col items-center gap-4 px-10 py-8 bg-muted rounded-[2rem] shadow-2xl border border-border/40"
          >
            <Loader2 size={40} className="animate-spin text-primary" />
            {loadingMessage && (
              <p className="text-sm font-bold text-foreground tracking-wide">{loadingMessage}</p>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
